var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("Advarsel")]),_vm._v(" "),_c('p',[_vm._v("\n    Du kan ikke skifte abonnement med dette nummer da du er logget ind som underbruger.\n    Kun mobilchefen selv kan skifte abonnment.\n  ")])])
}]

export { render, staticRenderFns }